import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BoardUser } from "src/app/model/board-user";
import { StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceActions from 'src/app/store/device/device.actions';

@Component({
	templateUrl: './board-user-delete.dialog.component.html',
	styles: `
	`
})

export class BoardUserDeleteDialogComponent implements OnInit {

	screenWidth: number;
	boardUser: BoardUser;

	constructor(
		private ref: DynamicDialogRef,
		private store: Store<AppState>,
		public config: DynamicDialogConfig
	) {
		if (config.data!== undefined && config.data.boardUser!== undefined) {
         this.boardUser = config.data.boardUser;
      }
	}

	ngOnInit(): void {
		this.onResize();
	}

	closeDialog(): void {
		this.ref.close();
	}

	submit() {
		this.store.dispatch(DeviceActions.deleteBoardUser({position: this.boardUser.Position, code: this.boardUser.Code}));
		this.closeDialog();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

}